(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laboosh-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('[data-laboosh-look]').forEach((section) => {
        if (section.dataset.lookReady) return;
        section.dataset.lookReady = 'true';
        const track = section.querySelector('[data-laboosh-look-track]');
        const cells = Array.from(track.children);
        const previous = section.querySelector('[data-look-prev]');
        const next = section.querySelector('[data-look-next]');
        const progress = section.querySelector('[data-look-progress]');
        const count = section.querySelector('[data-look-count]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let first = 0;
        let visible = 2;
        const update = () => {
          const bounds = track.getBoundingClientRect();
          const shown = cells.map((cell, index) => ({rect:cell.getBoundingClientRect(), index})).filter(({rect}) => rect.right > bounds.left + rect.width / 2 && rect.left < bounds.right - rect.width / 2);
          if (!shown.length) return;
          first = shown[0].index;
          visible = shown.length;
          const last = shown[shown.length - 1].index;
          count.textContent = (first + 1) + '–' + (last + 1) + ' / ' + cells.length;
          previous.disabled = first === 0;
          next.disabled = last === cells.length - 1;
          progress.style.width = (visible / cells.length * 100) + '%';
          progress.style.insetInlineStart = (first / cells.length * 100) + '%';
          section.querySelectorAll('[data-look-controls]').forEach(el => {el.hidden = track.scrollWidth <= track.clientWidth + 2;});
        };
        const move = direction => {
          const target = Math.max(0, Math.min(cells.length - visible, first + direction * visible));
          const rtl = getComputedStyle(track).direction === 'rtl';
          const distance = cells[target].offsetLeft - cells[0].offsetLeft;
          track.scrollTo({left:rtl ? -Math.abs(distance) : distance, behavior:reducedMotion.matches ? 'auto' : 'smooth'});
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive:true});
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(track).direction === 'rtl';
            move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        });
        new ResizeObserver(update).observe(track);
        section.querySelectorAll('[data-laboosh-quickadd]').forEach(wrap => {
          const button = wrap.querySelector('[data-laboosh-quickadd-open]');
          if (!wrap.querySelector('[data-laboosh-quickadd-overlay]')) return;
          const sync = () => button.setAttribute('aria-expanded', String(wrap.classList.contains('laboosh-product-card__quickadd--open')));
          sync();
          new MutationObserver(sync).observe(wrap, {attributes:true, attributeFilter:['class']});
        });
        update();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
